import styled from 'styled-components';
import Slider from 'react-slick';
import {
  digestPersonSlider, maxTablet, maxWidth1300, midTablet, sliderArrowIcon,
  wMedium,
} from 'Utils/utilsStyle';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import DigestTile from 'Components/common/components/DigestTile';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { PersonTheme } from 'Types/PersonTypes';
import DigestSkeleton from 'Components/common/skeleton/DigestSkeleton';
import classNames from 'classnames';

const Wrapper = styled.div`
  .heading-inner-page {
    .heading {
      display: flex;
      align-items: center;
      margin-top: 24px;
      &.digest-heading {
        font-size: 24px;
        font-weight: ${wMedium};
        @media all and (max-width: ${maxTablet}){
          font-size: 16px;
        }
      }
    }
  }
 
  .person-digest-wrap {
    > .slick-list {
      > {
        .slick-track {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
    .slick-disabled {
      display: none !important;
    }
    .slick-list {
      margin: 0 -20px;
      @media all and (min-width: 1600px) {
        margin: 0px -10px;
      }
      @media all and (max-width: ${maxWidth1300}) {
        margin: 0px -10px 0 0px;
      }
      @media all and (max-width: ${midTablet}) {
        margin: 0px -10px;
      }
      .slick-slide {
      }
    }
    .slick-arrow {
      &.slick-prev {
        z-index: 1;
        &:before {
          height: 32px;
          width: 18px;
          background-image: url(${sliderArrowIcon});
          content: '';
          position: absolute;
          top: 0px;
          left: 20px;
          transform: rotate(-180deg);
          @media all and (max-width: ${maxTablet}) {
            top: -10px;
            left: 5px;
          }
        }
        &:after {
          content: '';
          width: 60px;
          height: 218px;
          background-image: linear-gradient(to right,
           rgba(0, 0, 0, 0.6),
            rgba(0, 0, 0, 0.4),
             rgba(0, 0, 0, 0.2), 
             rgba(238, 238, 238, 0.2));
            position: absolute;
            right: -30px;
            top: -99px;
            z-index: -1;
            border-radius: 10px 0px 0px 10px;
            @media all and (max-width: ${maxTablet}) {
              top: -49px;
              height: 113px;
              width: 47px;
              right: -17px;
          }
        }
      }
      &.slick-next {
        &:before {
          height: 32px;
          width: 18px;
          background-image: url(${sliderArrowIcon});
          content: '';
          position: absolute;
          top: 0px;
          right: 10px;
          @media all and (max-width: ${maxTablet}) {
            top: -10px;
            right: 5px;
          }
        }
        &:after {
          content: '';
          width: 60px;
          height: 219px;
          background-image: linear-gradient(to right, rgba(238, 238, 238, 0.2),
           rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.4),
             rgba(0, 0, 0, 0.6));
          position: absolute;
          right: -20px;
          top: -100px;
          z-index: -1;
          border-radius: 10px 0px 0px 10px;
          @media all and (max-width: ${maxTablet}) {
            top: -50px;
            height: 113px;
            width: 47px;
          }
        }
      }
    }
  }
  .skeleton-box {
    margin-right: 10px;}
  .heading-inner-page{
    &.skeletonheading {
      margin-top: 20px;
    }
    margin-bottom: 10px;
  }
  .slick-prev {
    left: 10px;
  }
  .slick-next {
    right: 10px;
  }
  .global-tooltip-element {
    .ant-tooltip-content {
      width: 425px;
      .ant-tooltip-inner {
        .tooltip_wrapper {
          padding: 0px;
        }
        padding: 8px 56px 8px 8px;
      }
      .tooltip-text-tour {
        line-height: 18px;
      }
    }
  }
  
`;
type Props = {
  isLoading: boolean,
  personThemes?: PersonTheme[]
  createDigest?: (a: string) => void
} & typeof defaultProps;

const defaultProps = {
  personThemes: [] as PersonTheme[],
  createDigest: (a: string) => { },
};
const PersonDigestSlider = function PersonDigestSlider(props: Props) {
  const {
    isLoading, personThemes, createDigest,
  } = props;
  const getArticleSkeleton = () => (

    <DigestSkeleton />
  );

  const getDigestWidgets = () => (personThemes?.length
    ? (
      <Slider {...digestPersonSlider} className="person-digest-wrap">
        {personThemes?.map((widget) => (
          <DigestTile
            widgetId={widget.themeId}
            imagesURL={widget.imageUrl}
            title={widget.theme}
            themeId={widget.themeId}
            personWidget
            createDigest={createDigest}
          />
        ))}
      </Slider>
    ) : null
  );

  return (
    <Wrapper className="person-digest-slider-wrapper">
      <div className={classNames('heading-inner-page', { skeletonheading: isLoading })}>
        {isLoading
          ? <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" />
          : (personThemes?.length > 0
            && (
              <h1 className="heading digest-heading">
                Recommended Digests
                <HeadingWithToolTip
                  widthIcon="20px"
                  toolTipText="Send AI-generated digests to prospects with relevant, up-to-date content to get them engaged."
                />
              </h1>
            )
          )}
      </div>
      {isLoading ? (getArticleSkeleton()) : (
        getDigestWidgets()
      )}
    </Wrapper>
  );
};

PersonDigestSlider.defaultProps = defaultProps;
export default PersonDigestSlider;
